if (!customElements.get('paragraph-reveal')) {
  customElements.define('paragraph-reveal',
    class ParagraphReveal extends HTMLElement {
      constructor() {
        super()

        // ignore on mobile
        if (isMobile || window.innerWidth < 767) return;

        this.matchTargets = this.querySelectorAll('.p-image')
        const paragraph = this.querySelector('p')
        
        this.matchWords = []
        this.matchTargets.forEach((element) => {
          this.matchWords.push(element.dataset.text)
        })
        
        const uniqueWords = [...new Set(this.matchWords)]
        uniqueWords.forEach((word) => {
          paragraph.innerHTML = paragraph.innerHTML.replace(
            word,
            `<span class='p-replaced tw-underline tw-cursor-default' data-text='${word}' tabindex="0">${word}</span>`
          );
        })

        this.replacedWords = this.querySelectorAll(".p-replaced")
        this.replacedWords.forEach((element) => {
          element.addEventListener('mouseenter', this.reveal.bind(this, element))
          element.addEventListener('mouseleave', this.hide.bind(this, element))
          element.addEventListener('focus', this.reveal.bind(this, element))
          element.addEventListener('blur', this.hide.bind(this, element))
        })
      }

      reveal(element) {
        const linkedImages = this.querySelectorAll(`div[data-text*="${element.dataset.text}"]`)
        linkedImages.forEach((element) => {
          element.classList.add('tw-opacity-100','tw-translate-y-0')
          element.classList.remove('tw-opacity-0','tw--translate-y-6')
        })
      }

      hide(element) {
        const linkedImages = this.querySelectorAll(`div[data-text*="${element.dataset.text}"]`)
        linkedImages.forEach((element) => {
          element.classList.add('tw-opacity-0','tw--translate-y-6')
          element.classList.remove('tw-opacity-100','tw-translate-y-0')
        })
      }
    }
  )
}
